module.exports = "<div class=\"text-xs-center\">\r\n    <h1 class=\"display-3\">Thank You!</h1>\r\n    <p class=\"lead\"><strong>Your request for reset password has been sent, support will contact you soon! </strong></p>\r\n    <p class=\"lead\">\r\n      <a [routerLink]=\"['/login']\" class=\"btn btn-primary btn-sm\" role=\"button\">Go Back </a>\r\n    </p>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/resetPasswordreq.html
// module id = ./src/app/login/resetPasswordreq.html
// module chunks = main